export default __webpack_public_path__ + "static/media/pasieka.51e6b027.svg";